import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import Sidebar from './Sidebar.js';

const DIRECT_DEPOSIT_FORM_URL = 'https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf';

const DEFAULT_SIDEBAR_LINKS = [
  {
    label: 'Portal Dashboard',
    to: '/home',
    iconClass: 'bi-speedometer2',
    exact: true,
  },
  {
    label: 'Payments',
    to: '/payments',
    iconClass: 'bi-cash-coin',
  },
  {
    label: 'Messages & Alerts',
    to: '/main',
    iconClass: 'bi-chat-dots',
  },
  {
    label: 'My Documents',
    to: '/documents',
    iconClass: 'bi-folder2-open',
  },
  {
    label: 'Update Direct Deposit',
    action: 'directDeposit',
    iconClass: 'bi-file-earmark-arrow-down',
  },
  {
    label: 'Frequently Asked Questions',
    to: '/faq',
    iconClass: 'bi-question-circle',
  },
  {
    label: 'Settings',
    to: '/settings',
    iconClass: 'bi-gear',
  },
  {
    label: 'Log Out',
    action: 'signOut',
    iconClass: 'bi-box-arrow-right',
  },
];

const PortalPageLayout = ({
  user,
  children,
  showBanner = false,
  showSidebarForAuthenticated = true,
  sidebarLinks = DEFAULT_SIDEBAR_LINKS,
}) => {
  const { push } = useHistory();
  const [showDirectDepositModal, setShowDirectDepositModal] = useState(false);
  const shouldShowSidebar = Boolean(user && showSidebarForAuthenticated);

  const handleSidebarSignOut = async (event) => {
    if (event) {
      event.preventDefault();
    }

    await Auth.signOut();
    alert('Signed out');
    push('/public');
  };

  const handleDirectDepositClick = (event) => {
    event.preventDefault();
    setShowDirectDepositModal(true);
  };

  const resolvedSidebarLinks = sidebarLinks.map((link) => {
    if (link.action === 'signOut') {
      return {
        ...link,
        onClick: handleSidebarSignOut,
      };
    }

    if (link.action === 'directDeposit') {
      return {
        ...link,
        onClick: handleDirectDepositClick,
      };
    }

    return link;
  });

  return (
    <div className='App portal-page'>
      <NavMenu />
      {showBanner && <Banner />}

      <div className='portal-content-shell'>
        <div className={`portal-content-grid ${shouldShowSidebar ? 'has-sidebar' : 'no-sidebar'}`}>
          {shouldShowSidebar && (
            <Sidebar
              links={resolvedSidebarLinks}
              ariaLabel='Portal navigation'
            />
          )}
          <main className='portal-main-content'>
            {children}
          </main>
        </div>
      </div>

      <SITELINKS />

      <Modal show={showDirectDepositModal} onHide={() => setShowDirectDepositModal(false)} centered size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Update Direct Deposit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Download and complete the Direct Deposit Form to update your direct deposit information.
          </p>
          <p className='mb-0'>
            For assistance, contact HomebaseStatus@metrohousingboston.org.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowDirectDepositModal(false)}>
            Close
          </Button>
          <Button target='_blank' rel='noreferrer' href={DIRECT_DEPOSIT_FORM_URL}>
            Open Direct Deposit Form
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PortalPageLayout;
